module.exports = __webpack_public_path__ + "static/media/delete_lined.117c3680.svg";